import React, { forwardRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import API from '../../api/api.jsx';

// 베트남 동 통화로 변환하는 함수
function formatMoney(amount) {
	return new Intl.NumberFormat('vi-VN', {
		style    : 'currency',
		currency : 'VND',
	}).format(amount).replace(/[₫]/g,'').trim(); // 통화 기호만 제거
};

const allowOnlyNumbers = (input) => {
	const regex = /^[0-9.]*$/;
	return input.match(regex) ? input : '';
};

// 쉼표 등을 제거한 후 숫자로 변환
const convertToNumber = (value) => {
	const intValue = value.replace(/\./g,'').replace(/[^\d]/g,'');

	return intValue
};

// 대출신청 화면에서 대출정보 아코디언
const Loan002_01 = forwardRef(({SelectOptions1,SelectOptions2,SelectOptions3,SelectOptions4,SelectOptions5,customer_id,setLoan_application_id,}, ref) => {
	const { t } 			= useTranslation();	

	//url에 있는 loanApplicationId값
	const location          = useLocation();	
	const params            = new URLSearchParams(location.search);
	const loanApplicationId = params.get('loanApplicationId')	

	//날짜 기본값
	const defaultDate		= new Date();

	//버튼에 마우스가 올라갈때 hover
	const [hovered, setHovered] = useState(false);

	const handleMouseEnter = () => {
		setHovered(true);
    };

    const handleMouseLeave = () => {
		setHovered(false);
    };

	const buttonStyle = {
		backgroundColor : hovered ? '#286A45' : '#7DA390',
        color           : '#FFFFFF',
    };

	//대출정보 값		
	const [loan_date, setLoan_date] 					= useState(defaultDate);    //대출예정일
	const [execution_type, setExecution_type]           = useState('T01');	        //대출실행타입	
	const [remark, setRemark]       					= useState('');	            //적요
	const [saveBtn, setSaveBtn]       					= useState('대출정보 저장');
	const [loan_application_id, setLoan_ApplicationId]  = useState(loanApplicationId);
	const [status, setStatus]                           = useState('');     // 대출 신청 상태

	// const [status, setStatus]                           = useState('');     // 대출 신청 상태

	const [inputValue_01, setInputValue_01]             = useState(''); 	//대출정보-대출금액
	const [inputValue_02, setInputValue_02]             = useState(''); 	//대출정보-이자지급주기
	const [inputValue_03, setInputValue_03]             = useState(''); 	//대출정보-이자
	const [inputValue_04, setInputValue_04]             = useState(''); 	//대출정보-이자지급횟수
	const [inputValue_05, setInputValue_05]             = useState(''); 	//대출정보-일별이자액
	const [inputValue_06, setInputValue_06]             = useState(''); 	//대출정보-연체이자
	const [inputValue_07, setInputValue_07]             = useState('');  	//대출정보-연체유예일수

	const [value1, setValue1]                           = useState(SelectOptions1[0]);   	//상환방법
	const [value2, setValue2]                           = useState(SelectOptions2[0]);   	//이자지급주기
	const [value3, setValue3]                           = useState(SelectOptions3[0]);   	//이자
	const [value4, setValue4]                           = useState(SelectOptions4[0]);   	//이자지급시기
	const [value5, setValue5]                           = useState(SelectOptions5[0]);   	//연체이자

	// 클릭된 라디오 버튼의 값으로 execution_type 상태 변경
	const handleExecutionTypeChange = (e) => {
		// console.log(e.target.value)
        setExecution_type(e.target.value); 
    };

	const handleChangeSelect1 = (e) => {
		setValue1(e.target.value);
	};
	const handleChangeSelect2 = (e) => {
		setValue2(e.target.value);
	};
	const handleChangeSelect3 = (e) => {
		setValue3(e.target.value);
	};
	const handleChangeSelect4 = (e) => {
		setValue4(e.target.value);
	};
	const handleChangeSelect5 = (e) => {
		setValue5(e.target.value);
	};

	// input 값이 변경될 때 호출되는 함수	
	const handleChangeLoan_date = (e) => {		
		//저장할때 사용할 대출예정일
		setLoan_date(e)
	};
	// input 값이 변경될 때 호출되는 함수	
	const handleInputChangeInput_01 = (e) => {		
		const inputValue = e.target.value;
		// 숫자가 아닌 문자 제거하고 숫자만 남기기
		const numericValue = inputValue.replace(/\D/g,'').trim();			
		// 숫자를 한국 통화 형식으로 변환하여 state 업데이트
		setInputValue_01(formatMoney(Number(numericValue)));		
	};

	// input 값이 변경될 때 호출되는 함수	
	const handleInputChangeInput_05 = (e) => {
		const inputValue = e.target.value;
		// 숫자가 아닌 문자 제거하고 숫자만 남기기
		const numericValue = inputValue.replace(/\D/g, '');	
		// 숫자를 한국 통화 형식으로 변환하여 state 업데이트
		setInputValue_05(formatMoney(Number(numericValue)));
	};

	// 숫자만 입력되도록 처리하는 함수
	const handleInputChange = (e, setInputValue) => {
		// setInputValue('');
		const inputValue = e.target.value;
		const filteredValue = allowOnlyNumbers(inputValue);				
		// 숫자가 아닌 경우 이전 값 유지
		setInputValue(filteredValue)
	};

	// 대출정보 저장
	const handleSave = async (e) => {

		const currentDate = new Date();
		
		// console.log('inputValue_01 : [' , inputValue_01 , ']')
		// console.log('inputValue_02 : [' , inputValue_02 , ']')
		// console.log('inputValue_03 : [' , inputValue_03 , ']')
		// console.log('inputValue_04 : [' , inputValue_04 , ']')
		// console.log('inputValue_05 : [' , inputValue_05 , ']')
		// console.log('inputValue_06 : [' , inputValue_06 , ']')
		// console.log('inputValue_07 : [' , inputValue_07 , ']')

		if((inputValue_01 === '0' || inputValue_01 === 0) || (inputValue_02 === '0' || inputValue_02 === 0) || (inputValue_03 === '0' || inputValue_03 === 0) || (inputValue_04 === '0' || inputValue_04 === 0) || (inputValue_05 === '0' || inputValue_05 === 0)){			
			alert(t(`COMMON.필수 입력 사항이 입력되지 않았습니다.`, { defaultValue: '필수 입력 사항이 입력되지 않았습니다.' }))
			return;
		};

		if(inputValue_01 === '' || inputValue_02 === '' || inputValue_03 === '' || inputValue_04 === '' || inputValue_05 === '' || inputValue_06 === '' || inputValue_07 === '' ){
			alert(t(`COMMON.필수 입력 사항이 입력되지 않았습니다.`, { defaultValue: '필수 입력 사항이 입력되지 않았습니다.' }))
			return;
		};

		if(value2 === 'P02' && (inputValue_02 !== '1' && inputValue_02 !== 1)) {
			alert(t(`COMMON.월단위 이자지급주기는 1개월 단위로만 가능합니다.`, { defaultValue: '월단위 이자지급주기는 1개월 단위로만 가능합니다.' }))
			setInputValue_02('')
			return;
		};

		if(!customer_id){			
			//고객조회를 안했을 경우	
			alert('존재하지 않는 고객 ID [  ]');

		} else {	
			if(inputValue_06 === ''){
				setInputValue_06(0)
			}

			if(inputValue_07 === ''){
				setInputValue_07(0)
			}

			// 현재 날짜와 비교하여 이전인 경우 알림 표시
			const isBefore = loan_date < currentDate;
		
			// YYYY MM DD 만 비교하고 싶을 때
			const isSameDate =
				loan_date.getFullYear() === currentDate.getFullYear() &&
				loan_date.getMonth() === currentDate.getMonth() &&
				loan_date.getDate() === currentDate.getDate();

			// if (isBefore && !isSameDate) {
			// 	alert("Please Change the Date of loan");
			// 	return;
			// };

			try {								
				const savedData = await API.fetchLoan00201DataPOST({
					loan_application_id			: loan_application_id,			
					customer_id					: customer_id,			
					loan_date 					: loan_date,
					execution_type 				: execution_type,
					loan_amount 				: convertToNumber(inputValue_01),
					repayment_method 			: value1,
					interest_payment_cycle 		: inputValue_02,
					interest_payment_cycle_unit : value2,
					interest 					: inputValue_03,
					interest_unit 				: value3,
					interest_payment_period 	: value4,
					number_of_interest 			: inputValue_04,
					interest_per_day 			: inputValue_05,
					remark 						: remark,
					overdue_interest 			: inputValue_06,
					overdue_interest_type 		: value5,
					overdue_delay_day 			: inputValue_07,
				});
				setSaveBtn('대출정보 수정')
				setLoan_application_id(savedData[0])
				setLoan_ApplicationId(savedData[0])

				alert(t('LOAN_APPLICATION.대출정보가 등록되었습니다', { defaultValue: '대출정보가 등록되었습니다' }));

				if (savedData.code === 201) {
					console.log('대출 정보 저장 완료:', savedData);				
				}
			}catch (error) {
					console.error('고객 정보 저장 에러:', error);
				}   
		}
	};

	// 2023-12-19 (추가 : 정영진)
	// 대출 신청 상태를 부모 컴포넌트에 전달하기 위해서
	const getChildData = () => {

        const returnData = status;

        return returnData;
    };

    React.useImperativeHandle(ref, () => ({
        getChildData,
    }));

	// 화면 접근 시
	useEffect(() => {	
		
		if (value3 === 'T02') {
            if (inputValue_03 >= 100) {
                alert(t(`LOAN_APPLICATION.이자는 1을 넘을 수 없습니다`, { defaultValue: '이자는 1을 넘을 수 없습니다' }))
                setInputValue_03('')
            } else if (inputValue_03 < 0) {
                alert(t(`LOAN_APPLICATION.이자는 "-"일 수 없습니다`, { defaultValue: '이자는 "-"일 수 없습니다' }))
                setInputValue_03('')
            }
        }

		
		if (inputValue_03 || inputValue_01 || value3) {						
			if (value3 === 'T02') {			
				const result = Math.ceil((convertToNumber(inputValue_01)  * inputValue_03 * 0.01));
				setInputValue_05(result)
			} else if (value3 === 'T03') {
				const result = Math.ceil((convertToNumber(inputValue_01)  * inputValue_03 * 0.01)/30);
				setInputValue_05(result)
			} else if (value3 === 'T01') {
				const dailyInterest = (convertToNumber(inputValue_01)  / 1000000 * inputValue_03 );
				setInputValue_05(dailyInterest)
			} else{
				setInputValue_05(0)
			}
		}

		
	} , [t, value1, inputValue_03, inputValue_01, value3])

	useEffect(() => {

		//대출접수현황 링크를 타고 왔을때\
		if(loanApplicationId){
			const fetchLoan00201SelectData = async (loanApplicationId) => {
				try {
					const data = await API.fetchLoan00201SelectData({
						'loanApplicationId' 			: loanApplicationId,
					});	
					// 대출 신청 상태
					setStatus(data[0].loan_application_status);
					
					const loan_date = new Date(data[0]['loan_date'])
					// const loanAmount = formatMoney(data[0]['loan_amount']);			
					
					setLoan_date(loan_date)
					setInputValue_01(formatMoney(data[0]['loan_amount']))				
					setValue1(data[0]['repayment_method'])

					setInputValue_02(data[0]['interest_payment_cycle'])
					setValue2(data[0]['interest_payment_cycle_unit'])
					setInputValue_03(data[0]['interest'])
					setValue3(data[0]['interest_type'])
					setInputValue_04(data[0]['number_of_interest'])
					setValue4(data[0]['interest_payment_period'])
					setInputValue_05(data[0]['interest_per_day'])
					setInputValue_06(data[0]['overdue_interest'])
					setValue5(data[0]['overdue_interest_type'])
					setInputValue_07(data[0]['overdue_delay_day'])
					setRemark(data[0]['remark'])
					
					setExecution_type(data[0]['execution_type'])

					setSaveBtn('대출정보 수정')

				} catch (error) {
					console.error('Error fetching UserModal data:', error);
				}
			};
			fetchLoan00201SelectData(loanApplicationId)	
		}

		if(SelectOptions1[0] && SelectOptions2[0] && SelectOptions3[0] && SelectOptions4[0] && SelectOptions5[0]){

			//대출정보 select값 sort순으로 변경
			setValue1(SelectOptions1[0][0])
			setValue2(SelectOptions2[0][0])
			setValue3(SelectOptions3[0][0])
			setValue4(SelectOptions4[0][0])
			setValue5(SelectOptions5[0][0])
			
		}
		
	}, [loanApplicationId, SelectOptions1,	SelectOptions2,	SelectOptions3,	SelectOptions4,	SelectOptions5]);
	

	return (
		<div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordion">
			<div className="accordion-body bg-white text-gray-900 ">
				<table className="table table-panel mb-0">							
					<tbody>
						<tr>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.대출예정일', { defaultValue: '대출예정일' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}>
								<div className="input-group input-daterange">
									<div className='col'>
										<DatePicker
											className='form-control w-50'
											selected={loan_date}
											onChange={handleChangeLoan_date}
											dateFormat="dd/MM/yyyy"
											// minDate={new Date()}
										/>
										<div className="input-group-prepend position-absolute top-0 end-50 bottom-0 d-flex">
											<span className="input-group-text bg-none border-0">
												<i className='far fa-calendar' />
											</span>
										</div>
									</div>														
								</div>
							</td>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.대출실행타입', { defaultValue: '대출실행타입' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}>
							<div>
									<div className="form-check d-inline-block me-3">
										<input
											type="radio"
											className="form-check-input"
											name="execution_type"
											value="T01"
											id="radioRequired1"
											checked={execution_type === 'T01'}
											onChange={handleExecutionTypeChange}
										/>
										<label className="form-check-label" htmlFor="radioRequired1">
										{t('LOAN_APPLICATION.자동실행(은행)', { defaultValue: '자동실행(은행)' })}
										</label>
									</div>
									<div className="form-check d-inline-block">
										<input
											type="radio"
											className="form-check-input"
											name="execution_type"
											value="T02"
											id="radioRequired2"
											checked={execution_type === 'T02'}
											onChange={handleExecutionTypeChange}
										/>
										<label className="form-check-label" htmlFor="radioRequired2">
											{t('LOAN_APPLICATION.수동실행(인터넷뱅킹)', { defaultValue: '수동실행(인터넷뱅킹)' })}											
										</label>
									</div>
								</div>										
							</td>
						</tr>
						<tr>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.대출금액', { defaultValue: '대출금액' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}><input className="form-control w-50 text-end" value={inputValue_01} onChange={(e) => handleInputChangeInput_01(e, setInputValue_01)}/></td>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.상환방법', { defaultValue: '상환방법' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}>
								<select
									className="form-select w-50"
									onChange={handleChangeSelect1}
									value={value1}
								>									
									{SelectOptions1.map((option, index) => (
										<option key={index} value={option[0]}>
											{t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
											
										</option>
									))}

								</select>
							</td>
						</tr>
						<tr>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.이자지급주기', { defaultValue: '이자지급주기' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}>
								<div className="row">
									<div className="col pe-0">
										<input className="form-control pr-0" value={inputValue_02} onChange={(e) => handleInputChange(e, setInputValue_02)}/>
										{/* <input className="form-control" /> */}
									</div>
									<div className="col pe-0">
										<select
											className="form-select w-50"
											onChange={handleChangeSelect2}
											value={value2}
										>											
											{SelectOptions2.map((option, index) => (
												<option key={index} value={option[0]}>
													{t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
													{/* {option[0]} */}
												</option>
											))}

										</select>

									</div>
								</div></td>
							<td style={{width : `15%`}} className="align-middle"></td>
							<td style={{width : `35%`}}></td>
						</tr>
						<tr>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.이자', { defaultValue: '이자' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}>
								<div className="row">
									<div className="col pe-0">
										<input className="form-control pr-0" type="text" value={inputValue_03} onChange={(e) => handleInputChange(e, setInputValue_03)}/>
										{/* <input className="form-control" /> */}
									</div>
									<div className="col pe-0">

										<select
											className="form-select w-50"
											onChange={handleChangeSelect3}
											value={value3}
										>											
											{SelectOptions3.map((option, index) => (
												<option key={index} value={option[0]}>
													{t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
													{/* {option[0]} */}
												</option>
											))}

										</select>
										
									</div>
								</div>
							</td>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.이자지급시기', { defaultValue: '이자지급시기' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}>
								
										<select
											className="form-select w-50"
											onChange={handleChangeSelect4}
											value={value4}
										>											
											{SelectOptions4.map((option, index) => (
												<option key={index} value={option[0]}>
													{t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
													{/* {option[0]} */}
												</option>
											))}

										</select>
								
							</td>
						</tr>								
						<tr>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.이자지급횟수', { defaultValue: '이자지급횟수' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}><input className="form-control w-50" value={inputValue_04} onChange={(e) => handleInputChange(e, setInputValue_04)}/></td>
							<td style={{width : `15%`}} className="align-middle"></td>
							<td style={{width : `35%`}}></td>
						</tr>
						<tr>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.일별이자액', { defaultValue: '일별이자액' })}</td>
							<td style={{width : `35%`}}><input className="form-control w-50 text-end" value={inputValue_05} onChange={(e) => handleInputChangeInput_05(e, setInputValue_05)} readOnly placeholder="0"/></td>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.적요 (Remarks)', { defaultValue: '적요 (Remarks)' })}</td>
							<td style={{width : `35%`}}><input className="form-control w-50" value={remark} onChange={(e) => setRemark(e.target.value)}/></td>
						</tr>
						<tr>
							<td style={{width : `15%`}} className="align-middle">{t('REPORT.연체이자', { defaultValue: '연체이자' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}>
								<div className="row">
									<div className="col pe-0">
										<input className="form-control pr-0" type="text" value={inputValue_06} onChange={(e) => handleInputChange(e, setInputValue_06)}/>
										{/* <input className="form-control" /> */}
									</div>
									<div className="col pe-0">


										<select
											className="form-select w-50"
											onChange={handleChangeSelect5}
											value={value5}
										>											
											{SelectOptions5.map((option, index) => (
												<option key={index} value={option[0]}>
													{t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
													{/* {option[0]} */}
												</option>
											))}

										</select>
										
									</div>
								</div>
							</td>
							<td style={{width : `15%`}} className="align-middle">{t('LOAN_APPLICATION.연체유예일수', { defaultValue: '연체유예일수' })} <span className="text-danger">*</span></td>
							<td style={{width : `35%`}}><input className="form-control w-50" value={inputValue_07} onChange={(e) => handleInputChange(e, setInputValue_07)}/></td>
						</tr>										
					</tbody>
				</table>
				<div className = "p-1 pt-4 d-flex justify-content-center">
					{status === '' || status === 'S01' || status ==='S04' || status ==='S06' ?(<button type="button" className="btn text-white" style={buttonStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleSave}>
						{t(`LOAN_APPLICATION.${saveBtn}`, { defaultValue: saveBtn })}
					</button>
					) : null}
				</div>
			</div>
		</div>
	);
});

export default Loan002_01;
